import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FormProvider, useForm } from "react-hook-form";
import Button from "../../../../../components/Common/Button/Button";
import Input from "../../../../../components/Common/Input/Input";
import classes from "./CreateForumTopic.module.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import {
  createForumTopicActionHandler,
  editForumTopicActionHandler,
  isValidHttpUrl,
} from "../../../../../store/actions/actionHandlers/socialActionHandler";
import { mode } from "../../../../../utils/formModes";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import SelectThumbnailPopUp from "../../../../../components/Common/SelectThumbnailPopUp/SelectThumbnailPopUp";
import { getUserGroupsForForumTopicHandler } from "../../../../../store/actions/actionHandlers/distributeActionHandler";
import { FormattedMessage, useIntl } from "react-intl";

const topicSchema = yup.object().shape({
  name: yup.string().trim().required("Title is required"),
  description: yup.string().trim().required("Description is required"),
  group: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        UserGroupId: yup.number(),
      })
    )
    .min(1, "Select at least One User Group to proceed"),
});

const CreateForumTopic = ({
  setCreateForumTopicModal,
  selectedTopic,
  formMode,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const thumnailFileRef = useRef(null);
  const methods = useForm({
    resolver: yupResolver(topicSchema),
    defaultValues: {
      forumTopicRadioBtn: intl.formatMessage({ id: "PUBLIC" }),
    },
  });
  const {
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const formData = watch(["forumTopicRadioBtn", "thumbnailImageFile"]);
  const socialState = useSelector((state) => state.socialReducer);
  const { createForumTOpicLoading } = socialState;
  const radioBtnVal = useMemo(() => {
    return [
      intl.formatMessage({ id: "PUBLIC" }),
      intl.formatMessage({ id: "PRIVATE" }),
    ];
  }, [intl]);
  const [thumbnailEroorMsg, setThumbnailEroorMsg] = useState("");
  const [isSselectThumbnailModal, setIsSselectThumbnailModal] = useState(false);
  const [thumbnailFileName, setThumbnailFileName] = useState("");
  const [nameErrorMsg, setNameErrorMsg] = useState("");
  const [userGroup, setUserGroup] = useState([]);
  const [loader, setLoader] = useState(false);

  const setSelectedData = useCallback(
    (group) => {
      if (selectedTopic?.UserGroups?.length > 0) {
        let updatedUserGroup = group?.map((item) => {
          let updatedUserGroup = item;
          selectedTopic?.UserGroups?.forEach((data) => {
            if (item?.UserGroupId.toString() === data?.UserGroupId.toString()) {
              updatedUserGroup = { ...item, checked: true };
            }
          });
          return { ...updatedUserGroup, isVisible: true };
        });
        setUserGroup(updatedUserGroup);
      }
    },
    [selectedTopic]
  );

  useEffect(() => {
    if (formMode === mode.EDIT && selectedTopic) {
      setLoader(true);
      setValue("name", selectedTopic?.TopicName);
      setValue("description", selectedTopic?.TopicDescription);
      setValue("thumbnailImageFile", selectedTopic?.TopicThumbnailUrl);
      if (selectedTopic?.UserGroups?.length > 0) {
        setValue("forumTopicRadioBtn", radioBtnVal[1]);
        setValue("group", selectedTopic?.UserGroups);
      } else setValue("forumTopicRadioBtn", radioBtnVal[0]);
      dispatch(getUserGroupsForForumTopicHandler()).then((res) => {
        if (res.status === 200 && res.data) {
          setLoader(false);
          const sortedData = res.data.UserGroups.sort((a, b) => {
            if (a.Name < b.Name) return -1;
            if (a.Name > b.Name) return 1;
            return 0;
          });
          const filteredData = sortedData.filter(
            (item) => item.Name.toLowerCase() !== "default"
          );

          const updatedData = filteredData?.map((item) => {
            return { ...item, isVisible: true };
          });
          setSelectedData(updatedData);
          setLoader(false);
        }
      });
    }
  }, [
    dispatch,
    formMode,
    selectedTopic,
    setSelectedData,
    radioBtnVal,
    setValue,
  ]);

  useEffect(() => {
    setLoader(true);
    dispatch(getUserGroupsForForumTopicHandler()).then((res) => {
      if (res.status === 200 && res.data) {
        const sortedData = res.data.UserGroups.sort((a, b) => {
          if (a.Name < b.Name) return -1;
          if (a.Name > b.Name) return 1;
          return 0;
        });
        const filteredData = sortedData.filter(
          (item) => item.Name.toLowerCase() !== "default"
        );
        const updatedData = filteredData?.map((item) => {
          return { ...item, isVisible: true };
        });
        setUserGroup(updatedData);
        setLoader(false);
      }
    });
  }, []);

  const onSubmit = (data) => {
    if (!nameErrorMsg) {
      let usergroupIds = [];
      data?.group?.forEach((item) => {
        usergroupIds.push(item?.UserGroupId);
      });
      const forumTopicObj = {
        TopicName: data?.name,
        TopicDescription: data?.description,
        TopicThumbnailUrl:
          typeof data?.thumbnailImageFile?.[0] === "object" &&
          !Array.isArray(data?.thumbnailImageFile?.[0]) &&
          data?.thumbnailImageFile?.[0] !== null
            ? data?.thumbnailImageFile?.[0]
            : data?.thumbnailImageFile,
        UserGroupIds: usergroupIds || [],
      };
      if (
        (formData?.[0] === radioBtnVal[0] ||
          (usergroupIds.length > 0 && formData?.[0] === radioBtnVal[1])) &&
        !thumbnailEroorMsg
      ) {
        if (formMode === mode.ADD) {
          dispatch(
            createForumTopicActionHandler(
              forumTopicObj,
              setCreateForumTopicModal
            )
          );
        } else {
          const updatedForumTopicObj = {
            ...forumTopicObj,
            Duration: null,
            Id: selectedTopic?.Id,
          };
          dispatch(
            editForumTopicActionHandler(
              updatedForumTopicObj,
              setCreateForumTopicModal
            )
          );
        }
      }
    }
  };

  const handleThumbnailChange = (e) => {
    e.preventDefault();
    let files = e.target.files[0];
    if (files) {
      setThumbnailEroorMsg("");
    } else {
      setThumbnailEroorMsg("Thumbnail is required");
    }
    const accept = ["image/png", "image/jpeg", "image/gif", "image/bmp"];
    if (!accept.includes(files.type)) {
      setValue("thumbnailImageFile", "");
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Please select a valid format from [.png, .jpg, .gif, .bmp]"
        )
      );
    }
  };

  const okBtnClick = () => {
    thumnailFileRef?.current?.click();
  };

  const titleChange = (e) => {
    const val = e?.target.value.trim();
    const regex = new RegExp(/^[a-zA-Z0-9:_@#?|'`\][ ]*$/);
    if (!regex.test(val)) {
      setNameErrorMsg(
        "Only alphanumeric and special characters like ':#@?[]_`| are allowed"
      );
    } else {
      setNameErrorMsg("");
    }
  };

  return (
    <div>
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.createForumTopic}
        >
          <div className={classes.radiobtn}>
            {radioBtnVal.map((data) => {
              return (
                <Input
                  label={data}
                  name="forumTopicRadioBtn"
                  fieldName={data}
                  value={data}
                  type="radio"
                  labelColor="light"
                  direction="row-reverse"
                  width="2"
                  height="2"
                  disabled={formMode === mode.EDIT ? true : false}
                  key={data}
                />
              );
            })}
          </div>
          <div className={classes.title}>
            <Input
              label={<FormattedMessage id="FORUM_TITLE" />}
              placeholder="Enter Name"
              name="name"
              fieldName="name"
              labelColor="dark"
              width="37"
              error={errors?.name?.message}
              required
              maxLength="100"
              onChange={titleChange}
            />
            {nameErrorMsg && (
              <div className={classes.nameErrorMsg}>{nameErrorMsg}</div>
            )}
          </div>
          {formData?.[0] === radioBtnVal[1] && (
            <div className={classes.searchGroup}>
              <Input
                name="group"
                type="noSearchTags"
                fieldName="Name"
                fieldValue="UserGroupId"
                placeholder="Search Group"
                buttonLabel={<FormattedMessage id="P_SELECT_GROUP" />}
                label="Select Group / Group's"
                height="5"
                width="37"
                required
                searchable={true}
                searchTagsList={userGroup}
                handleTagList={(tagsList) => setUserGroup(tagsList)}
                error={errors?.group?.message}
                loading={loader}
              />
            </div>
          )}
          <Input
            label={<FormattedMessage id="FORUM_DESCRIPTION" />}
            name="description"
            placeholder="Enter Description"
            labelColor="light"
            width="37"
            rows={3}
            error={errors?.description?.message}
            required
            maxLength="500"
          />
          <div>
            <Input
              label="Upload Topic Thumbnail"
              name="thumbnailImageFile"
              labelColor="dark"
              hidden
              type="file"
              required
              error={errors?.thumbnailImageFile?.message}
              onChange={handleThumbnailChange}
              accept=".png, .jpg, .gif, .bmp"
              fileInputView={
                formMode === mode.EDIT && isValidHttpUrl(formData?.[1])
                  ? true
                  : false
              }
              handleClickFileButton={() => setIsSselectThumbnailModal(true)}
              fileInputName={thumbnailFileName}
              handleCancelFileInput={() => setThumbnailFileName("")}
            />
            {thumbnailEroorMsg && (
              <div className={classes.errorMsg}>{thumbnailEroorMsg}</div>
            )}
          </div>
          <div className={classes.submitBtn}>
            <Button
              type="submit"
              label={<FormattedMessage id="SAVE_TXT" />}
              small
              dark
              backgroundColor={createForumTOpicLoading ? undefined : "#D31B61"}
              loading={createForumTOpicLoading}
              onClick={() => {
                if (formData?.[1]?.length > 0) setThumbnailEroorMsg("");
                else setThumbnailEroorMsg("Thumbnail is required");
              }}
            />
          </div>
        </form>
      </FormProvider>
      <SelectThumbnailPopUp
        isOpenModal={isSselectThumbnailModal}
        setIsOpenModal={setIsSselectThumbnailModal}
        fileRef={thumnailFileRef}
        setValue={setValue}
        setThumbnailFileName={setThumbnailFileName}
        okBtnClick={okBtnClick}
        setErrorMsg={setThumbnailEroorMsg}
      />
    </div>
  );
};

export default CreateForumTopic;
